<template>
  <q-dialog
    :visible="isVisible"
    :title="dialogTitle"
    width="60%"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <el-form :model="form" size="small" :rules="rules" ref="ruleForm" label-width="110px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品编码:" prop="goodsCode">
            <el-input v-model.trim="form.goodsCode" @blur="onInputBlur"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品名称:">
            <el-input v-model.trim="form.goodsName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品定位:">
            <el-select v-model="form.location" placeholder="全部" filterable>
              <el-option v-for="item in goodsAttrLocationSelect" :label="item.optionValue" :key="item.optionValue" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
        </el-col>
        <el-col :span="12">
          <el-form-item label="品类:">
            <el-select v-model="form.category" placeholder="全部" filterable>
              <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="风格:">
            <el-select v-model="form.style" placeholder="全部" filterable>
              <el-option v-for="item in styleList" :label="item.optionValue" :key="item.optionValue" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属类型:">
            <el-select
              v-model="form.type"
              @change="form.aclasses = []"
              :disabled="form.oneToOneFlag=='是' || !form.isUpdate"
              clearable>
              <el-option
                v-for="(item, index) in types"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属店铺:" prop="aclasses">
            <el-select 
              v-model="form.aclasses" 
              multiple 
              collapse-tags 
              clearable
              filterable
              :multiple-limit="form.type !== '核心A' ? 0 : 1"
              :disabled="form.oneToOneFlag=='是' || !form.type || !form.isUpdate">
              <el-option
                v-for="(item, index) in shopOptions"
                :key="index"
                :label="item.shopName"
                :value="item.shopId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货周期:" prop="deliveryCycle">
            <el-input-number :controls="false" size="small" v-model="form.deliveryCycle" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开始时间:" prop="startDate">
            <el-date-picker v-model="form.startDate" value-format="yyyy-MM-dd" size="small" type="date" style="width: 150px" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU推广名称:">
            <el-input v-model.trim="form.skuPromotionName" :disabled="!hasPromotionNamePermission"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="loading">确定</el-button>
      <el-button type="success" @click="handleNotifyOpen" :loading="loading" v-permission="'ec-pc-new#informationManagement#noticeBtn'">确定并通知店铺</el-button>
    </div>
  </q-dialog>
</template>

<script>
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog';

export default {
  name: 'AddEditDialog',
  components: { notifyStoreDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    },
    clearanceStatus: {
      type: Array,
      default: () => []
    },
    styleList: {
      type: Array,
      default: () => []
    },
    categoryList: {
      type: Array,
      default: () => []
    },
    aClassSelect: {
      type: Array,
      default: () => []
    },
    goodsAttrLocationSelect: {
      type: Array,
      default: () => []
    },
    shopOptions: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    },
    hasPromotionNamePermission: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.row ? '编辑' : '新增'
    }
  },
  data() {
    const checkTypesValid = (rule, value, callback, form) => {
      if (form.type) {
        if (!value || (value && !value.length)) {
          callback(new Error('所属类型有值，所属店铺不能为空。'));
        } else {
          callback()
        }
      } else {
        callback();
      }
    }
    return {
      loading: false,
      form: {
        aclasses: [],
        startDate: ''
      },
      rules: {
        goodsCode: [
          { required: true, message: '商品编码不能为空！', trigger: 'blur' }
        ],
        clearanceStatus: [
          { required: true, message: '清仓销售状态不能为空！', trigger: 'change' }
        ],
        aclasses: [
          { validator: (rule, value, callback) => { checkTypesValid(rule, value, callback, this.form) } }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      if (this.row) {
        this.form = JSON.parse(JSON.stringify(this.row));
        if (!this.form.deliveryCycle) {
          delete this.form.deliveryCycle;
        }
        this.selectInit();
      } else {
        this.form = {
          aclasses: [],
          startDate: ''
        }
      }
      if (!this.form.clearanceStatus) {
        this.$set(this.form, 'clearanceStatus', '正常')
      }
    },
    // 把需要用id匹配的参数名替换成对应的id
    selectInit() {
      // 传 ids []
      let aclasses = this.form['aclassId'] && this.form['aclassId'].split(',') || [];

      // 传 id
      let location = this.form['location'];
      location = this.goodsAttrLocationSelect.filter(v => v['optionValue'] === location).map(v => v['id'])[0];

      // 传 id
      let category = this.form['category'];
      category = this.categoryList.filter(v => v['optionValue'] === category).map(v => v['id'])[0];

      // 传 id
      let style = this.form['style'];
      style = this.styleList.filter(v => v['optionValue'] === style).map(v => v['id'])[0];

      this.$set(this.form, 'aclasses', aclasses)
      this.form['location'] = location;
      this.form['category'] = category;
      this.form['style'] = style;
    },
    //商品编号光标移除事件
    onInputBlur() {
      if (!this.form.goodsCode) {
        return;
      }
      this.$q.goods.marketDateGetGoodsName({ params: { goodsCode: this.form.goodsCode } })
        .then((res) => {
          if (res.code == 200) {
            this.$set(this.form, 'goodsName', res.data)
          } else {
            this.$message.error(res.message);
          }
        });
    },
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          await this.submit()
        } else {
          this.$message('提交参数有误')
        }
      })
    },
    handleNotifyOpen() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.$emit('notify-open', this.form, this.row)
        } else {
          this.$message('提交参数有误')
        }
      })
    },
    submit() {
      this.loading = true
      let data = {
        aclasses: this.form.aclasses,
        category: this.form.category,
        clearanceStatus: this.form.clearanceStatus,
        goodsCode: this.form.goodsCode,
        goodsName: this.form.goodsName,
        id: this.form.id,
        location: this.form.location,
        marketOn: this.form.marketOn,
        marketOnBegin: this.form.marketOnBegin,
        marketOnEnd: this.form.marketOnEnd,
        style: this.form.style,
        type: this.form.type,
        startDate: this.form.startDate,
        deliveryCycle: this.form.deliveryCycle,
        skuPromotionName: this.form.skuPromotionName,
      }
      return this.$q.goods
        .baseAttrEdit({ data })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('编辑成功')
            this.isVisible = false
            this.$emit('success', this.form)
          } else {
            this.$message.fail(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 供父组件调用的提交方法（用于通知店铺功能）
    async submitAndNotify() {
      return await this.submit()
    },
    getForm() {
      return this.form
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .el-form-item
  margin-bottom 22px !important
>>> .el-select, >>> .el-date-editor, >>> .el-input
  width 280px !important
.dialog-footer
  text-align center
  padding 15px 0
</style>
